import { OligoProperties } from './properties';

export type ClientParamDef<T extends any> = {
  type: string;
  id: string;
  name: string;
  value: T;
  descriptions: string[];
  hidden: boolean;
  disabled: boolean;
  invalid: boolean;
  errors?: string[];
  nameLabel?: string;
  descriptionLabel?: string;
};

export type SkuClientParamDef<T extends any> = {
  sku: string;
} & ClientParamDef<T>;

export type TextSymbolsDef = {
  valid: string[];
  invalid: string[];
  description: string;
};

export type TextLimitDef = {
  min: number;
  max: number;
  description: string;
};

export type TextInputClientParamDef = {
  textSymbols: TextSymbolsDef[];
  textLimits: TextLimitDef[];
  pristine?: boolean;
} & ClientParamDef<string>;

export type InternalMod = {
  code: string;
  name: string;
  quantity: number;
  sku: string;
};

export type SkuTextInputClientParamDef = {
  internalMod: InternalMod[];
} & TextInputClientParamDef;

export type SelectionTypeClientParamDef<T extends object, U extends object> = {
  selected: T;
} & ClientParamDef<U[]>;

export type SelectionClientParamDef = SelectionTypeClientParamDef<SkuClientParamDef<string>, SkuClientParamDef<string>>;

export type MultiSelectionSkuTextInputClientParamDef = SelectionTypeClientParamDef<SkuTextInputClientParamDef[], SkuTextInputClientParamDef>;

export type MultiSelectionSkuClientParamDef = SelectionTypeClientParamDef<Array<SkuClientParamDef<string>>, SkuClientParamDef<string>>;

export type CheckInputClientParamDef = ClientParamDef<boolean>;

export type Optional = object | null | undefined;

export type OligoState = 'VALID' | 'INVALID';

export type OligoStatus = {
  state: OligoState;
  violatingParamIds: string[];
};

export const OligoStates: {
  INVALID: OligoState;
  VALID: OligoState;
} = {
  VALID: 'VALID',
  INVALID: 'INVALID',
};

export type OligoDef<T extends object> = {
  basic: {
    researcherName: T;
    oligoName: T;
    oligoValue: T;
    scale: T;
    purification: T;
    format: T;
    delivery: T;
    prime5Mod: T;
    prime3Mod: T;
  };
  advanced: {
    alternate: T[];
    handling: T[];
  };
};

export type OligoParamDefs = {
  basic: {
    researcherName: TextInputClientParamDef;
    oligoName: TextInputClientParamDef;
    oligoValue: SkuTextInputClientParamDef;
    scale: SelectionClientParamDef;
    purification: SelectionClientParamDef;
    format: SelectionClientParamDef;
    delivery: SelectionClientParamDef;
    prime5Mod: SelectionClientParamDef;
    prime3Mod: SelectionClientParamDef;
  } & ClientParamDef<Optional>;
  advanced: {
    alternate: MultiSelectionSkuTextInputClientParamDef;
    handling: MultiSelectionSkuClientParamDef;
  } & ClientParamDef<Optional>;
  properties: OligoProperties;
  status: OligoStatus;
};

export type ProjectParamDefs = {
  projectName: TextInputClientParamDef;
  oligo: OligoParamDefs;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/models/param-def.ts